import React, { PureComponent } from 'react'
import {
  Button,
  FormLabel,
  Grid,
  ListItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
  Tooltip,
} from '@material-ui/core'
import moment from 'moment'
import MenuItem from '@material-ui/core/MenuItem'
import { connect } from 'react-redux'
import { TableCellWithText } from '../common/PureItems'

class QuickBookSyncJobs extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      rowsPerPage: 10,
    }
  }

  handleChangePage = (page, count) => (event) => {
    if (count >= 1 && count <= Math.ceil(this.props.jobs.total / this.state.rowsPerPage)) {
      this.setState({
        page: count,
      })
      this.getQuickBookSyncJobs((count - 1) * 10, this.state.rowsPerPage)
    }
    this.forceUpdate()
  }

  getQuickBookSyncJobs(start, limit) {
    this.props.getQuickBookSyncJobs(start, limit)
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value })
    this.forceUpdate()
    this.getQuickBookSyncJobs((this.state.page - 1) * 10, event.target.value)
  }

  render() {
    let total = this.props.jobs.total || 0
    const pages = Math.ceil(total / this.state.rowsPerPage)
    let page = this.state.page

    return (
      <div>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper className="margin-top-small">
            <div className="table-scroll">
              {this.props.jobs && this.props.jobs.values && this.props.jobs.values.length > 0 ? (
                <div>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCellWithText>EmployeeID</TableCellWithText>
                        <TableCellWithText>Sync Type</TableCellWithText>
                        <TableCellWithText>Status</TableCellWithText>
                        <TableCellWithText>Triggered at</TableCellWithText>
                        <TableCellWithText>Completed at</TableCellWithText>
                        <TableCellWithText>Error</TableCellWithText>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.props.jobs &&
                        this.props.jobs.values &&
                        this.props.jobs.values.map((logs, index) => {
                          return (
                            <TableRow key={index}>
                              <TableCellWithText>{logs.employeeId}</TableCellWithText>
                              <TableCellWithText>{logs.qboSyncType}</TableCellWithText>
                              <TableCellWithText>{logs.qboJobStatus}</TableCellWithText>
                              <TableCellWithText>
                                {moment(logs.triggerTime).format('hh:mmA')}{' '}
                                {moment(logs.triggerTime).format('MM/DD/YYYY')}
                              </TableCellWithText>
                              <TableCellWithText>
                                {moment(logs.completedTime).format('hh:mmA')}{' '}
                                {moment(logs.completedTime).format('MM/DD/YYYY')}
                              </TableCellWithText>
                              <TableCellWithText>{logs.errorMsg}</TableCellWithText>
                            </TableRow>
                          )
                        })}
                    </TableBody>
                    <TableFooter>
                      <TableRow>
                        <TableCell colSpan={5}>
                          <ul className="pagination">
                            <li>Rows per page</li>
                            <li>
                              <Select
                                value={this.state.rowsPerPage}
                                onChange={this.handleChangeRowsPerPage}
                                displayEmpty
                              >
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={20}>20</MenuItem>
                                <MenuItem value={30}>30</MenuItem>
                              </Select>
                            </li>
                            <li>
                              {this.state.page} of {pages}
                            </li>
                            <li>
                              <Tooltip title="Previous" aria-label="Previous">
                                <Button onClick={this.handleChangePage('prv', page - 1)}>
                                  <i className="material-icons">chevron_left</i>
                                </Button>
                              </Tooltip>
                            </li>
                            <li>
                              <Tooltip title="Next" aria-label="Next">
                                <Button onClick={this.handleChangePage('next', page + 1)}>
                                  <i className="material-icons">chevron_right</i>
                                </Button>
                              </Tooltip>
                            </li>
                          </ul>
                        </TableCell>
                      </TableRow>
                    </TableFooter>
                  </Table>
                </div>
              ) : (
                <ListItem>
                  <FormLabel component="legend">Jobs not available</FormLabel>
                </ListItem>
              )}
            </div>
          </Paper>
        </Grid>
      </div>
    )
  }
}

export default connect((state) => ({ dispatch: state.dispatch }))(QuickBookSyncJobs)



// WEBPACK FOOTER //
// ./src/components/QuickBook/QuickBookSyncJobs.js